const DatenschutzPage = () => {
  return (
    <div data-testid="datenschutz-page" style={{ backgroundColor: '#372d24' }}>
      {/* Hero Section */}
      <section className="pt-12 pb-6" style={{ backgroundColor: '#372d24' }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-6" style={{ fontFamily: 'Manrope, sans-serif', color: '#dbcebe' }}>
              Datenschutzerklärung
            </h1>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="py-8 pb-16" style={{ backgroundColor: '#372d24' }}>
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-invert max-w-none">
            <h2 className="text-2xl font-bold mb-4" style={{ fontFamily: 'Manrope, sans-serif', color: '#dbcebe' }}>
              1. Datenschutz auf einen Blick
            </h2>

            <h3 className="text-xl font-semibold mt-8 mb-4" style={{ fontFamily: 'Manrope, sans-serif', color: '#dbcebe' }}>
              Allgemeine Hinweise
            </h3>
            <p style={{ color: '#a89f94' }}>
              Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können.
            </p>

            <h3 className="text-xl font-semibold mt-8 mb-4" style={{ fontFamily: 'Manrope, sans-serif', color: '#dbcebe' }}>
              Datenerfassung auf dieser Website
            </h3>
            <p style={{ color: '#a89f94' }}>
              <strong style={{ color: '#dbcebe' }}>Wer ist verantwortlich für die Datenerfassung auf dieser Website?</strong><br />
              Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten können Sie dem Abschnitt „Hinweis zur Verantwortlichen Stelle" in dieser Datenschutzerklärung entnehmen.
            </p>

            <p className="mt-4" style={{ color: '#a89f94' }}>
              <strong style={{ color: '#dbcebe' }}>Wie erfassen wir Ihre Daten?</strong><br />
              Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich z. B. um Daten handeln, die Sie in ein Kontaktformular eingeben.
            </p>

            <p className="mt-4" style={{ color: '#a89f94' }}>
              Andere Daten werden automatisch oder nach Ihrer Einwilligung beim Besuch der Website durch unsere IT-Systeme erfasst. Das sind vor allem technische Daten (z. B. Internetbrowser, Betriebssystem oder Uhrzeit des Seitenaufrufs). Die Erfassung dieser Daten erfolgt automatisch, sobald Sie diese Website betreten.
            </p>

            <p className="mt-4" style={{ color: '#a89f94' }}>
              <strong style={{ color: '#dbcebe' }}>Wofür nutzen wir Ihre Daten?</strong><br />
              Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website zu gewährleisten. Andere Daten können zur Analyse Ihres Nutzerverhaltens verwendet werden.
            </p>

            <p className="mt-4" style={{ color: '#a89f94' }}>
              <strong style={{ color: '#dbcebe' }}>Welche Rechte haben Sie bezüglich Ihrer Daten?</strong><br />
              Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft, Empfänger und Zweck Ihrer gespeicherten personenbezogenen Daten zu erhalten. Sie haben außerdem ein Recht, die Berichtigung oder Löschung dieser Daten zu verlangen. Wenn Sie eine Einwilligung zur Datenverarbeitung erteilt haben, können Sie diese Einwilligung jederzeit für die Zukunft widerrufen. Außerdem haben Sie das Recht, unter bestimmten Umständen die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen.
            </p>

            <h2 className="text-2xl font-bold mt-12 mb-4" style={{ fontFamily: 'Manrope, sans-serif', color: '#dbcebe' }}>
              2. Hinweis zur Verantwortlichen Stelle
            </h2>
            <div className="p-6 rounded-lg mb-8 border border-[#4a3d32]" style={{ backgroundColor: '#2a2219' }}>
              <p className="mb-0" style={{ color: '#dbcebe' }}>
                <strong style={{ color: '#dbcebe' }}>Bastian Ebbecke - Trockenbau</strong><br />
                Tornower Dorfstr. 4<br />
                16225 Eberswalde<br />
                Deutschland<br /><br />
                Telefon: +49 162 1608568<br />
                E-Mail: info@trockenbau-be.de
              </p>
            </div>
            <p style={{ color: '#a89f94' }}>
              Verantwortliche Stelle ist die natürliche oder juristische Person, die allein oder gemeinsam mit anderen über die Zwecke und Mittel der Verarbeitung von personenbezogenen Daten (z. B. Namen, E-Mail-Adressen o. Ä.) entscheidet.
            </p>

            <h2 className="text-2xl font-bold mt-12 mb-4" style={{ fontFamily: 'Manrope, sans-serif', color: '#dbcebe' }}>
              3. Datenerfassung auf dieser Website
            </h2>

            <h3 className="text-xl font-semibold mt-8 mb-4" style={{ fontFamily: 'Manrope, sans-serif', color: '#dbcebe' }}>
              Kontaktformular
            </h3>
            <p style={{ color: '#a89f94' }}>
              Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
            </p>
            <p className="mt-4" style={{ color: '#a89f94' }}>
              Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO, sofern Ihre Anfrage mit der Erfüllung eines Vertrags zusammenhängt oder zur Durchführung vorvertraglicher Maßnahmen erforderlich ist. In allen übrigen Fällen beruht die Verarbeitung auf unserem berechtigten Interesse an der effektiven Bearbeitung der an uns gerichteten Anfragen (Art. 6 Abs. 1 lit. f DSGVO) oder auf Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO) sofern diese abgefragt wurde.
            </p>

            <h3 className="text-xl font-semibold mt-8 mb-4" style={{ fontFamily: 'Manrope, sans-serif', color: '#dbcebe' }}>
              Anfrage per E-Mail oder Telefon
            </h3>
            <p style={{ color: '#a89f94' }}>
              Wenn Sie uns per E-Mail oder Telefon kontaktieren, wird Ihre Anfrage inklusive aller daraus hervorgehenden personenbezogenen Daten (Name, Anfrage) zum Zwecke der Bearbeitung Ihres Anliegens bei uns gespeichert und verarbeitet. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
            </p>

            <h2 className="text-2xl font-bold mt-12 mb-4" style={{ fontFamily: 'Manrope, sans-serif', color: '#dbcebe' }}>
              4. Ihre Rechte
            </h2>
            <p style={{ color: '#a89f94' }}>
              Sie haben folgende Rechte hinsichtlich der Sie betreffenden personenbezogenen Daten:
            </p>
            <ul className="list-disc pl-6 mt-4" style={{ color: '#a89f94' }}>
              <li>Recht auf Auskunft</li>
              <li>Recht auf Berichtigung oder Löschung</li>
              <li>Recht auf Einschränkung der Verarbeitung</li>
              <li>Recht auf Widerspruch gegen die Verarbeitung</li>
              <li>Recht auf Datenübertragbarkeit</li>
            </ul>
            <p className="mt-4" style={{ color: '#a89f94' }}>
              Sie haben zudem das Recht, sich bei einer Datenschutz-Aufsichtsbehörde über die Verarbeitung Ihrer personenbezogenen Daten durch uns zu beschweren.
            </p>

            <h2 className="text-2xl font-bold mt-12 mb-4" style={{ fontFamily: 'Manrope, sans-serif', color: '#dbcebe' }}>
              5. Webanalyse mit Loglesk
            </h2>
            <p style={{ color: '#a89f94' }}>
              Wir nutzen auf unserer Website Loglesk, einen datenschutzfreundlichen Webanalysedienst. Loglesk erfasst anonymisierte Nutzungsdaten, um uns bei der Verbesserung unserer Website zu unterstützen. Dabei werden keine Cookies verwendet und keine personenbezogenen Daten gespeichert.
            </p>
            <p className="mt-4" style={{ color: '#a89f94' }}>
              Die Verarbeitung erfolgt auf Grundlage unseres berechtigten Interesses an der statistischen Analyse des Nutzerverhaltens zu Optimierungszwecken gemäß Art. 6 Abs. 1 lit. f DSGVO. Die erhobenen Daten werden nicht an Dritte weitergegeben.
            </p>
            <p className="mt-4" style={{ color: '#a89f94' }}>
              Weitere Informationen finden Sie unter: <a href="https://loglesk.io" target="_blank" rel="noopener noreferrer" style={{ color: '#dbcebe', textDecoration: 'underline' }}>https://loglesk.io</a>
            </p>

            <h2 className="text-2xl font-bold mt-12 mb-4" style={{ fontFamily: 'Manrope, sans-serif', color: '#dbcebe' }}>
              6. SSL-/TLS-Verschlüsselung
            </h2>
            <p style={{ color: '#a89f94' }}>
              Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher Inhalte, wie zum Beispiel Bestellungen oder Anfragen, die Sie an uns als Seitenbetreiber senden, eine SSL-bzw. TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie daran, dass die Adresszeile des Browsers von „http://" auf „https://" wechselt und an dem Schloss-Symbol in Ihrer Browserzeile.
            </p>
            <p className="mt-4" style={{ color: '#a89f94' }}>
              Wenn die SSL- bzw. TLS-Verschlüsselung aktiviert ist, können die Daten, die Sie an uns übermitteln, nicht von Dritten mitgelesen werden.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default DatenschutzPage;
